// extracted by mini-css-extract-plugin
export default {"container":"ActionsGrid_container__JrDHS","header":"ActionsGrid_header__WIuM0","label":"ActionsGrid_label__KmX6p"};